import columns from '../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PRECON_RESCON_CONSIGNMENTS_DETAILS.id,
    mainReportId: ReportDefinitions.PRECON_RESCON_CONSIGNMENTS_SUMMARY.id,
    requestParams: {
      countryCode: rowInfo.original.consignment.countryCode,
      conDocNo: rowInfo.original.consignment.conDocNo,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    DateColumn,
    NavigationColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    ExternalConsignmentLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'Consignment',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('ID', 'consignment.id')
          .withWidth(120)),
        new DateColumn('Completion date', 'consignment.completionDate').withWidth(120),
        new TextColumn('Completion time', 'consignment.completionTime').withWidth(120),
        new TextColumn('Category', 'consignment.category'),
        new TextColumn('Departure location', 'consignment.departureLocation').withWidth(150),
        new TextColumn('Arrival location', 'consignment.arrivalLocation').withWidth(120),
      ],
    },
    {
      Header: 'RESCON',
      columns: [
        new DateColumn('First scan date', 'rescon.firstScanDate').withWidth(120),
        new TextColumn('First scan time', 'rescon.firstScanTime').withWidth(120),
        new DateColumn('Last scan date', 'rescon.lastScanDate').withWidth(120),
        new TextColumn('Last scan time', 'rescon.lastScanTime').withWidth(120),
        new TextColumn('Last - first', 'rescon.lastMinusFirst'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('PRECON', 'receptacles.precon'), getDetailsTabNavOptions),
        new NonZeroNumberColumn('RESCON', 'receptacles.rescon'),
        new NonZeroPercentageColumn('%', 'receptacles.percentage'),
      ],
    },
    {
      Header: 'Differences',
      columns: [
        new NonZeroNumberColumn('Receptacle type', 'differences.receptacleType').withWidth(120),
        new NonZeroNumberColumn('Mail class', 'differences.mailClass'),
        new NonZeroNumberColumn('Documents included', 'differences.documentsIncluded').withWidth(150),
        new NonZeroNumberColumn('Dangerous goods', 'differences.dangerousGoods').withWidth(150),
        new NonZeroNumberColumn('Format of contents', 'differences.formatOfContents').withWidth(150),
        new NonZeroNumberColumn('Handling class', 'differences.handlingClass').withWidth(120),
        new NonZeroNumberColumn('Tracked', 'differences.tracked'),
        new NonZeroNumberColumn('Exempt', 'differences.exempt'),
        new NonZeroNumberColumn('Weight', 'differences.weight'),
      ],
    },
  ];
};
